// import { options } from 'i18n';
import { isProduction } from 'helpers/environmentHelpers';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from 'i18n';
import type { InitOptions } from 'i18next';
import { createInstance } from 'i18next';
import ChainedBackend from 'i18next-chained-backend';
import resourcesToBackend from 'i18next-resources-to-backend';

const options: InitOptions = {
  lng: 'cs',
  fallbackLng: DEFAULT_LANGUAGE,
  ns: ['common_old'],
  defaultNS: 'common_old',
  backend: {
    backends: [
      resourcesToBackend(
        (lng: string, ns: string) => import(`../../translations/${ns}/${lng}.json`)
      )
    ]
  },
  supportedLngs: SUPPORTED_LANGUAGES,
  debug: !isProduction(),

  appendNamespaceToMissingKey: false,
  parseMissingKeyHandler: (key: string) => `?_${key}_?`
};

const i18n = createInstance(options);

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18n.use(ChainedBackend).init();

export { i18n as i18nInit };
